export default __webpack_public_path__ + "static/media/余氯分析仪.f8d564a5.png";